import { render, staticRenderFns } from "./SegmentSettingsForm.vue?vue&type=template&id=d23bd3f6"
import script from "./SegmentSettingsForm.vue?vue&type=script&lang=js"
export * from "./SegmentSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports